import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { Word } from '@attain-apps/string-builder'

import type * as models from '../../../../models'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    setModal: store.actions.standalone({
      data: ({
        widgetRef,
      }: {
        widgetRef?: ents.core.mosaic.Widget.Ref
      }): models.widget.Ref | undefined =>
        widgetRef && {
          ...widgetRef,
          // TODO: Generating a new ID for each modal instance may cause issues
          // when reopening the same modal. Consider using a deterministic ID
          // based on modal content or purpose if consistency is needed.
          id: Word.generate(),
        },
      reducer: ({ data, state }) => ({
        ...state,
        widgetRef: data,
      }),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
